<template lang="pug">
.payment-step
  validation-provider(:rules="{ required: { allowFalse: false } }")
    input.hidden(type="checkbox" :value="!!form.payment.id")

  .panel.mb-8
    .box
      .preview
        .icon
          svg(
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          )
            path(
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.3"
              d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            )
        .data
          //- .field-preview
          //-   .label Netto
          //-   .field-value {{ net | moneyFormat(currency) }}
          //- .field-preview
          //-   .label Lieferkosten
          //-   .field-label {{ 0 | moneyFormat(currency) }}
          //- .field-preview
          //-   .label MwSt.
          //-   .field-label {{ cart.tax | moneyFormat(currency) }}
          .field-preview
            .label Gesamtsumme
            .field-value
              h3.text-2xl {{ cart.sum | moneyFormat(currency) }}
      template(v-if="methods.length === 1")
        hr.my-4
        PaymentMethod(
          v-for="(method, i) in methods" :key="method.id"
          :data="method"
          :active="method.id === form.payment.id"
          :show-divider="i + 1 < methods.length"
          :show-label="true"
          @select="select"
        )

  .no-payment-methods.mb-4(v-if="!methods.length")
    .alert.error
      p Momentan stehen keine Zahlungsmethoden zur Verfügung.

  .payment-methods(v-if="methods.length > 1")
    h4.mb-2.text-xl.text-center Zahlungsmethode
    .panel.mb-8
      .box
        PaymentMethod(
          v-for="(method, i) in methods" :key="method.id"
          :data="method"
          :active="method.id === form.payment.id"
          :show-divider="i + 1 < methods.length"
          @select="select"
        )
</template>

<script>
import { mapGetters } from 'vuex';

import { get } from '@/helpers';

import { ValidationProvider } from 'vee-validate';
import PaymentMethod from '@/extensions/shop/components/CheckoutStepper/Steps/Partials/PaymentMethod';

export default {
    name: 'PaymentStep',
    props: {
        form: {
            type: Object,
            required: true
        }
    },
    components: {
        ValidationProvider,
        PaymentMethod
    },
    computed: {
        currency() {
            return (
                get(this.customer, 'customerGroup.currency.iso4217') ||
                get(this.defaultCustomerGroup, 'customerGroup.currency.iso4217') ||
                'EUR'
            );
        },
        net() {
            return this.cart.sum - this.cart.tax;
        },
        methods() {
            return get(this.cms, 'shop.paymentMethods') || [];
        },
        ...mapGetters({
            cms: 'CMS',
            customer: 'shop/customer',
            defaultCustomerGroup: 'shop/defaultCustomerGroup',
            cart: 'shop/cart'
        })
    },
    methods: {
        select(method) {
            this.form.payment = method;
        }
    },
    mounted() {
        if (!this.form.payment.id && this.methods.length === 1) {
            this.form.payment = this.methods[0];
        }
    }
};
</script>

<style lang="sass" scoped>
.no-payment-methods
  width: 100%
  @screen md
    @apply mx-auto
    width: 580px
</style>
